interface LittleTextProps {
    text: string
    className?: string
}
export const LittleText = ({
    text,
    className
}: LittleTextProps): JSX.Element => {
    return (
        <p className={`text-xs font-light whitespace-pre-line ${className}`}>
            {text}
        </p>
    )
}
